import Header from "./common/Header";

import axios from "axios";
import { TileView } from "devextreme-react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Footer from "./common/Footer";
import { notifyMsg } from "./common/notify";

import { allMenuItems } from "./data";
import { hasAnyPermission } from "../utils/hasPermission";
import RenderMenuItem from "./RenderMenuItem";

import "./index.css";
import Login from "./Login";

import { getRandomInt } from "./common/math";

import { useLocation } from "react-router-dom";
import ChangePassword from "./ChangePassword";

export default function Home() {
  const formLoginRef = useRef(null);
  const formChangePasswordRef = useRef(null);

  const [formData, setFormData] = useState(null);
  const [changeExistingPassword, setChangeExistingPassword] = useState(false);

  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.userInfo);

  const location = useLocation();
  const from = location.state?.from?.pathname;

  useEffect(async () => {
    document.title = "BeTree";
  }, []);

  useEffect(async () => {
    if (userInfo.employeeNo) {
      const svgNumber = getRandomInt(1, 14); // 1-13 범위
      document.getElementById("page-container").style.backgroundImage = `url(/BeTreeImg/svg/${svgNumber}.svg)`;
    } else {
      document.getElementById("page-container").style.backgroundImage = "none";
    }
  }, [userInfo.employeeNo]);

  const isReviewer = userInfo.jd === "RV";

  const filteredMenu = allMenuItems.filter((item) => {
    if (item.reviewerOnly) return isReviewer;
    if (isReviewer) return false;
    if (item.divOnly && item.divOnly !== userInfo.div) return false;
    // 하나라도 있으면 진입 가능. 화면 안에서 무엇을 할 수 있는지는 다시 권한이 가른다.
    if (item.permAny && !hasAnyPermission(userInfo.permissions, item.permAny)) return false;
    return true;
  });

  const tileProps = isReviewer
    ? { height: 220, baseItemHeight: 180, baseItemWidth: 150, width: 190 }
    : {
        height: Math.ceil(filteredMenu.length / 3) * 170,
        baseItemHeight: 144,
        baseItemWidth: 120,
        width: 440,
      };

  const onItemClick = (e) => {};

  return (
    <React.Fragment>
      <div id="page-container">
        <div id="content-wrap">
          {userInfo.employeeNo && !changeExistingPassword && (
            <div>
              <Header title={""} menuDataSource={null} />
              <TileView
                id="menu_TileView"
                items={filteredMenu}
                itemRender={RenderMenuItem}
                height={tileProps.height}
                baseItemHeight={tileProps.baseItemHeight}
                baseItemWidth={tileProps.baseItemWidth}
                width={tileProps.width}
                direction={"vertical"}
                style={{
                  margin: "auto",
                  marginTop: "120px",
                  background: "rgba(0, 0, 0, .35)",
                  borderRadius: "10px",
                }}
                keyExpr="id"
                onItemClick={onItemClick}
              />
            </div>
          )}
          {!userInfo.employeeNo && !changeExistingPassword && (
            <Login
              formLoginRef={formLoginRef}
              setChangeExistingPassword={setChangeExistingPassword}
            />
          )}
          {changeExistingPassword && (
            <ChangePassword
              changeExistingPassword={changeExistingPassword}
              setChangeExistingPassword={setChangeExistingPassword}
            />
          )}
        </div>
        <footer id="footer">
          <Footer />
        </footer>
      </div>
    </React.Fragment>
  );
}
